import React from "react";
import color from "../../Constants/colors";
import { Grid } from "@mui/material";

const SplashScreen = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        backgroundColor: color.white,
      }}
    >
      <Grid
        container
        sx={{
          backgroundColor: "#fefefe",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          alignContent: "center",
          width: "50%",
          margin: "auto",
        }}
        direction="column"
        alignItems="center"
        justifyContent="center"
        spacing={4}
      >
        <Grid item>
          <img
            src="/logo_big_blue.png"
            alt="Logo"
            style={{
              width: "50vw",
              maxWidth: "350px",
              height: "auto",
            }}
          />
        </Grid>
        <Grid item>
          <img
            src="/loaderElipsa.gif"
            alt="Loader"
            style={{
              width: "100%",
              maxWidth: "100px",
              height: "auto",
              marginTop: "-0.25rem",
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default SplashScreen;
